export enum JobsGroupByEnum {
  account = 'account',
  pickupLocation = 'pickupLocation',
  dropoffLocation = 'dropoffLocation'
}
